import moment from 'moment-timezone';
import numeral from 'numeral';
import * as constants from '@/util/constants';

const INTERP_FORMAT_AGE = 'age';
const INTERP_FORMAT_GENDER = 'gender';
const INTERP_FORMAT_DATE = 'date';
const INTERP_FORMAT_DATETIME = 'datetime';
const INTERP_FORMAT_TIME = 'time';
const INTERP_FORMAT_NUMBER = 'number';
const INTERP_FORMAT_DECIMALS = 'decimals';
const INTERP_FORMAT_CURRENCY = 'currency';

const INTERP_FORMAT_LOWERCASE = 'lowercase';
const INTERP_FORMAT_UPPERCASE = 'uppercase';
const INTERP_FORMAT_CAPITALIZE = 'capitalize';
const INTERP_FORMAT_TRIM = 'trim';

const INTERP_FORMAT_GROUP_TIME = [
  INTERP_FORMAT_TIME,
  INTERP_FORMAT_DATE,
  INTERP_FORMAT_DATETIME,
];

const INTERP_FORMAT_GROUP_NUMBER = [
  INTERP_FORMAT_NUMBER,
  INTERP_FORMAT_DECIMALS,
  INTERP_FORMAT_CURRENCY,
];

export default t => (value, format) => {
  if (format === INTERP_FORMAT_LOWERCASE) {
    return String(value).toLowerCase();
  } else if (format === INTERP_FORMAT_UPPERCASE) {
    return String(value).toUpperCase();
  } else if (format === INTERP_FORMAT_CAPITALIZE) {
    return String(value).charAt(0).toUpperCase() + String(value).slice(1);
  } else if (format === INTERP_FORMAT_TRIM) {
    return String(value).trim();
  }

  if (format === INTERP_FORMAT_AGE) {
    if (Number(value) === constants.AGE_BOUNDS_MIN) {
      return t('format.age.min', { age: value });
    } else if (Number(value) === constants.AGE_BOUNDS_MAX) {
      return t('format.age.max', { age: value });
    }
  }

  if (format === INTERP_FORMAT_GENDER) {
    if (value.length > 1) {
      return t('terms.gender.all');
    } else if (value.indexOf(constants.GENDER_MALE) >= 0) {
      return t('terms.gender.male');
    } else if (value.indexOf(constants.GENDER_FEMALE) >= 0) {
      return t('terms.gender.female');
    }
  }

  if (INTERP_FORMAT_GROUP_TIME.indexOf(format) >= 0) {
    const momentTime = value instanceof moment ? value : moment(value);
    return momentTime.format(t(`format.time.${format}`));
  }

  if (INTERP_FORMAT_GROUP_NUMBER.indexOf(format) >= 0) {
    return numeral(parseInt(value, 10)).format(t(`format.number.${format}`))
      .replace(/\$/g, t('_internal.currency_symbol'));
  }

  return value;
};



// WEBPACK FOOTER //
// ./src/util/i18n-interpolation.js